const getKlaroConfig = () => {
    const language = window.localStorage.getItem('language') || 'de';

    const showMoreButton = `
        <button type="button" id="klaro-show-more-button" onclick="
            const showMoreButton = document.getElementById('klaro-show-more-button');
            const showMoreText = document.getElementById('klaro-show-more');
            
            showMoreText.classList.toggle('klaro-hide-element');
            if (showMoreText.classList.contains('klaro-hide-element')) {
                showMoreButton.textContent = 'Mehr Anzeigen';
            } else {
                showMoreButton.textContent = 'Weniger Anzeigen';
            }
        ">
            Mehr anzeigen
        </button>
    `;

    return {
        lang: language,
        acceptAll: true,
        // Change the number of days in the consentModal text if you change this property
        cookieExpiresAfterDays: 30,
        mustConsent: true,
        storageMethod: 'localStorage',
        htmlTexts: true,
        translations: {
            de: {
                privacyPolicyUrl: '/privacy',
                acceptAll: 'Alle Cookies akzeptieren',
                acceptSelected: 'Auswahl akzeptieren',
                consentModal: {
                    title: 'Veranstaltungskalender Dresden Elbland –' +
                        ' <span style="white-space:nowrap;">Unsere Cookie-Richtlinien</span>',
                    description:  `
                        <div id="klaro-show-more" class="klaro-hide-element">
                            Dieser Dienst, der von der Dresden Marketing GmbH bereitgestellt wird, nutzt Cookies.<br />
                            Einige von ihnen sind essenziell, während andere uns helfen, diese Website und Ihre
                            Erfahrung zu verbessern. Durch die Zustimmung erklären Sie sich mit der Verwendung von
                            Cookies einverstanden.<br />
                            Akzeptierte Cookies werden unterschiedlich lange auf ihrem Rechner gespeichert.
                            Weitergehende Informationen, z.B. wie Sie der Verwendung von Cookies jederzeit
                            widersprechen können, finden Sie in unserer Datenschutzerklärung. Es besteht keine
                            Verpflichtung, der Verarbeitung Ihrer Daten zuzustimmen, um dieses Angebot nutzen zu
                            können. Bitte beachten Sie, dass aufgrund individueller Einstellungen möglicherweise nicht
                            alle Funktionen der Website zur Verfügung stehen.<br />
                            Einige Services verarbeiten personenbezogene Daten in den USA. Mit Ihrer Einwilligung zur
                            Nutzung dieser Services stimmen Sie auch der Verarbeitung Ihrer Daten in den USA gemäß
                            Art. 49 (1) lit. a DSGVO zu. Der EuGH stuft die USA als Land mit unzureichendem Datenschutz
                            nach EU-Standards ein. So besteht etwa das Risiko, dass US-Behörden personenbezogene Daten
                            in Überwachungsprogrammen verarbeiten, ohne bestehende Klagemöglichkeit für Europäer. Von
                            den Services die wir nutzen, haben MapBox, Youtube und Vimeo ihren Sitz in den USA.
                        </div>

                        ${showMoreButton}
                    `,
                },
                purposes: {
                    analytics: {
                        description: 'Statistik Cookies erfassen Informationen anonym. Diese Informationen helfen uns zu ' +
                            'verstehen, wie unsere Besucher unsere Website nutzen. Die Datenerfassung erfolgt auf unseren ' +
                            'eigenen Servern und ihre Daten werden nicht an Dritte weitergegeben.',
                        title: 'Erfassung von Nutzerverhalten',
                    },
                    externalMedia: {
                        description: 'Integration von Inhalten aus Drittdiensten wie Vimeo oder YouTube. Wenn ' +
                            'deaktiviert, werden einige Inhalte nicht dargestellt.',
                        title: 'Einbindung von externen Medien',
                    },
                    functional: {
                        description: 'Diese Dienste sind für die korrekte Funktion dieser Website unerlässlich. Sie ' +
                            'können sie hier nicht deaktivieren, da diese Seite sonst nicht richtig funktionieren würde.',
                        title: 'Dienstbereitstellung',
                    },
                    mapDisplay: {
                        description: 'Integration von Karten durch MapBox. Wenn deaktiviert, werden einige Inhalte ' +
                            'nicht dargestellt.',
                        title: 'Einbindung von Karten',
                    },
                },
            },
            en: {
                privacyPolicyUrl: '/privacy',
                consentModal: {
                    title: 'Calendar of events Dresden Elbland –' +
                        ' <span style="white-space:nowrap;">Our cookie policy</span>',
                    description:  `
                        <div id="klaro-show-more" class="klaro-hide-element"> 
                            This service, which is provided by Dresden Marketing GmbH, uses cookies.<br />
                            Some of them are essential, while others help us to improve this website and your
                            experience. By consenting, you agree to the use of cookies.<br />
                            Accepted cookies are stored on your computer for different lengths of time. Further
                            information, e.g. how you can object to the use of cookies at any time, can be found in our
                            privacy policy. There is no obligation to consent to the processing of your data in order
                            to use this offer. Please note that due to individual settings, not all functions of the
                            website may be available.<br />
                            Some services process personal data in the USA. By consenting to the use of these services,
                            you also consent to the processing of your data in the USA in accordance with Art. 49 (1)
                            lit. a GDPR. The ECJ classifies the USA as a country with insufficient data protection
                            according to EU standards. For example, there is a risk that US authorities process 
                            personal data in surveillance programs without existing legal remedies for Europeans. Of 
                            the services we use, MapBox, Youtube and Vimeo are based in the USA.
                        </div>

                        ${showMoreButton}
                    `,
                },
                purposes: {
                    analytics: {
                        description: 'Statistical cookies collect anonymous information. This information helps us to ' +
                            'understand how our visitors use our website. Data collection takes place on our own servers ' +
                            'and your data will not be passed on to third parties.',
                        title: 'Collection of user behavior',
                    },
                    externalMedia: {
                        description: 'Integration of content from third-party services such as Vimeo or YouTube. If ' +
                            'disabled, some content will not be displayed.',
                        title: 'Integration of external media',
                    },
                    functional: {
                        description: 'These services are essential for the proper functioning of this website. You ' +
                            'cannot disable them here, as this page would not work properly otherwise.',
                        title: 'Service provision',
                    },
                    mapDisplay: {
                        description: 'Integration of maps by MapBox. If disabled, some content will not be displayed.',
                        title: 'Integration of maps',
                    }
                }
            }
        },
        services: [
            {
                name: 'klaro',
                translations: {
                    de: {
                        description: 'Speichert Ihre Cookie-Auswahl und ihre Spracheinstellung für 30 Tage.',
                        title: 'Einstellungen-Cookie',
                    },
                    en: {
                        description: 'Stores your cookie selection and your language setting for 30 days.',
                        title: 'Settings Cookie',
                    }
                },
                purposes: ['functional'],
                required: true,
            },
            {
                name: 'matomo',
                translations: {
                    zz: {
                        title: 'Matomo',
                    },
                    de: {
                        description: 'Um unsere Website zu verbessern, nutzen wir Matomo um das Nutzerverhalten besser ' +
                            'verstehen zu können. Dieser Cookie wird für 30 Tage gespeichert.',
                    },
                    en: {
                        description: 'To improve our website, we use Matomo to better understand user behavior. This ' +
                            'cookie is stored for 30 days.',
                    }
                },
                purposes: ['analytics'],
                cookies: [
                    [/^_pk_.*$/, '/', 'localhost'],
                    [/^_mtm_.*$/, '/', 'localhost'],
                    [/^MATOMO.*$/, '/', 'localhost'],
                ],
                callback: function (consent) {
                    const _paq = window._paq;

                    if (_paq !== undefined) {
                        if (consent === true) {
                            _paq.push(['setVisitorCookieTimeout', 2592000]);
                            _paq.push(['setConsentGiven']);
                            _paq.push(['setCookieConsentGiven']);
                        } else {
                            _paq.push(['forgetConsentGiven']);
                            _paq.push(['forgetCookieConsentGiven']);
                        }
                    }
                },
            },
            {
                name: 'vimeo',
                translations: {
                    zz: {
                        title: 'Vimeo',
                    },
                    de: {
                        description: 'Einbindung externer Videos von Vimeo. Dieser Cookie wird für 400 Tage gespeichert.',
                    },
                    en: {
                        description: 'Integration of external videos from Vimeo. This cookie is stored for 400 days.',
                    }
                },
                purposes: ['externalMedia'],
            },
            {
                name: 'youtube',
                translations: {
                    zz: {
                        title: 'YouTube',
                    },
                    de: {
                        description: 'Einbindung externer Videos von YouTube. Es wird lediglich ein Cookie mit Ihrer ' +
                            'Zustimmung zum Abspielen von YouTube-Videos gespeichert ("Nocookie"). Dieser Cookie läuft ' +
                            'nach 2 Jahren ab.',
                    },
                    en: {
                        description: 'Integration of external videos from YouTube. Only a cookie with your consent to ' +
                            'play YouTube videos is stored ("nocookie"). This cookie expires after 2 years.',
                    },
                },
                purposes: ['externalMedia'],
            },
            {
                name: 'mapbox',
                translations: {
                    zz: {
                        title: 'MapBox',
                    },
                    de: {
                        description: 'Einbindung externer Inhalte (Karten) von MapBox. Es werden keine Cookies auf ihrem Gerät gespeichert.',
                    },
                    en: {
                        description: 'Integration of external content (maps) from MapBox. No cookies are stored on your device.',
                    },
                },
                purposes: ['mapDisplay'],
            }
        ],
    };
};

export default getKlaroConfig;
